import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { useWishlist } from '../../context/WishlistContext';
import './WishlistHeartButton.css';

/**
 * Overlay heart for collectible / hero card / marketplace tiles.
 * itemType: 'heroCard' | 'collectible' | 'marketplace'
 */
const WishlistHeartButton = ({ itemType, item, className = '' }) => {
    const { user } = useContext(UserContext);
    const { isWishlisted, toggleWishlist } = useWishlist();
    const navigate = useNavigate();
    const location = useLocation();
    const [popping, setPopping] = useState(false);
    const [busy, setBusy] = useState(false);

    const itemId =
        itemType === 'heroCard'
            ? item?.heroCardId ?? item?.HeroCardId
            : itemType === 'marketplace'
              ? item?.marketplaceItemId ?? item?.MarketplaceItemId
              : item?.collectionItemId ?? item?.CollectionItemId;
    const active = isWishlisted(itemType, itemId);
    const label = active ? 'Remove from wishlist' : 'Add to wishlist';

    const handleClick = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.currentTarget.blur();

        if (!user) {
            navigate('/login', {
                state: {
                    redirectTo: `${location.pathname}${location.search || ''}`,
                    message: 'Log in to save items to your wishlist.',
                },
            });
            return;
        }

        if (busy) return;
        setBusy(true);
        setPopping(true);

        try {
            const result = await toggleWishlist({ itemType, item });
            if (!result.ok && result.reason === 'auth') {
                navigate('/login', {
                    state: {
                        redirectTo: `${location.pathname}${location.search || ''}`,
                        message: 'Log in to save items to your wishlist.',
                    },
                });
            }
        } finally {
            window.setTimeout(() => setPopping(false), 420);
            setBusy(false);
        }
    };

    return (
        <button
            type="button"
            className={[
                'wishlist-heart',
                active ? 'is-active' : '',
                popping ? 'is-popping' : '',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
            aria-label={label}
            aria-pressed={active}
            aria-busy={busy}
            title={label}
            onClick={handleClick}
        >
            <span className="wishlist-heart-tooltip" aria-hidden="true">
                {label}
            </span>
            <svg
                className="wishlist-heart-icon"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    className="wishlist-heart-path"
                    d="M12 21s-6.7-4.35-9.33-8.1C.7 10.05 1.3 6.4 4.2 5.05c1.85-.85 4.05-.35 5.3 1.25L12 9.1l2.5-2.8c1.25-1.6 3.45-2.1 5.3-1.25 2.9 1.35 3.5 5 1.53 7.85C18.7 16.65 12 21 12 21z"
                />
            </svg>
        </button>
    );
};

export default WishlistHeartButton;
